exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-62de098e]{overflow:hidden}td[data-v-62de098e],th[data-v-62de098e]{max-width:150px}", ""]);

// exports
